export default __webpack_public_path__ + "static/media/total-leaves-taken.64fff6f5.svg";